<section class="cmn-innerpage-wrapper new-chart-accounts">
    <h2>{{leadId ? 'Update Lead' : 'Create Lead'}}</h2>
    <form [formGroup]="createLeadForm">
      <div class="chart-account-form-wrapper">
        <div class="form-wrapper">
          <label for="">Lead name<span class="red">*</span></label>
          <mat-form-field>
            <input matInput placeholder="Enter name" formControlName="leadName" />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
              createLeadForm.get('leadName')!.invalid &&
              createLeadForm.get('leadName')!.touched
            " class="error">Lead name is required.</mat-error>
            </span>
          </div>
        </div>
        <div class="form-wrapper">
          <label for="">Lead Code<span class="red">*</span></label>
          <mat-form-field>
            <input matInput placeholder="Enter Code" formControlName="leadCode" />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
              createLeadForm.get('leadCode')!.invalid &&
              createLeadForm.get('leadCode')!.touched
            " class="error">Lead Code is required.</mat-error>
            </span>
          </div>
        </div>
        <div class="form-wrapper">
          <label for="">Email<span class="red">*</span></label>
          <mat-form-field>
            <input matInput placeholder="Enter email" formControlName="email" />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
              createLeadForm.get('email')!.invalid &&
              createLeadForm.get('email')!.touched
            " class="error">Email is required.</mat-error>
             <mat-error *ngIf="createLeadForm.get('email')?.errors?.['email']" class="error">
              Please enter a valid email address.
            </mat-error>
            </span>
          </div>
        </div>
        <!-- <div class="form-wrapper" >
          <label for="">Status</label>
          <mat-form-field>
            <mat-select placeholder="Select Account" formControlName="status">
              <mat-option *ngFor="let status of leadStatus"
                value={{status}}>{{status}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
              createLeadForm.get('status')!.invalid &&
              createLeadForm.get('status')!.touched
            " class="error">Status is required.</mat-error>
            </span>
          </div>
        </div> -->
        <div class="form-wrapper">
            <label for="">Phone <span class="red">*</span></label>
            <mat-form-field>
              <input matInput placeholder="Phone" formControlName="phone"/>
              <mat-error
                *ngIf="
                  createLeadForm.get('phone')!.touched &&
                  createLeadForm.get('phone')!.hasError('required')
                "
                >Phone is required.</mat-error>
                <mat-error *ngIf="createLeadForm.get('phone')?.errors?.['pattern']" class="error">
                Phone number must be valid.</mat-error>
            </mat-form-field>
          </div>
        <!-- <div class="form-wrapper">
          <label for="">Description</label>
          <mat-form-field>
            <textarea matInput placeholder="max 500 characters" formControlName="description"></textarea>
          </mat-form-field>
        </div> -->
        <div class="form-wrapper">
          <label for="">Source<span class="red">*</span></label>
          <mat-form-field>
            <input matInput placeholder="Enter source" formControlName="source" />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
              createLeadForm.get('source')!.invalid &&
              createLeadForm.get('source')!.touched
            " class="error">Source is required.</mat-error>
            </span>
          </div>
        </div>
        <div class="form-wrapper">
          <label for="">Industry<span class="red">*</span></label>
          <mat-form-field>
            <input matInput placeholder="Enter industry" formControlName="industry" />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
              createLeadForm.get('industry')!.invalid &&
              createLeadForm.get('industry')!.touched
            " class="error">Industry is required.</mat-error>
            </span>
          </div>
        </div>
        <div class="form-wrapper">
          <label for="">Company Name<span class="red">*</span></label>
          <mat-form-field>
            <input matInput placeholder="Enter Company Name" formControlName="companyName" />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
              createLeadForm.get('companyName')!.invalid &&
              createLeadForm.get('companyName')!.touched
            " class="error">Company Name is required.</mat-error>
            </span>
          </div>
        </div>
        <div class="form-wrapper">
          <label for="">Expected Value<span class="red">*</span></label>
          <mat-form-field>
            <input matInput placeholder="Enter Expected Value" formControlName="expectedValue" />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
              createLeadForm.get('expectedValue')!.invalid &&
              createLeadForm.get('expectedValue')!.touched
            " class="error">Expected Value is required.</mat-error>
              <mat-error *ngIf="
              createLeadForm.get('expectedValue')!.hasError('pattern')
            " class="error">Expected  alue should be a number.</mat-error>
            </span>
          </div>
        </div>
        <div class="form-wrapper">
          <label for="">Expected Close Date <span class="red">*</span></label>
          <mat-form-field>
            <input matInput [matDatepicker]="picker" formControlName="expectedCloseDate" placeholder="Select Expected Close Date" />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
                createLeadForm.get('expectedCloseDate')!.touched &&
                createLeadForm.get('expectedCloseDate')!.hasError('required')
              ">Expected Close Date is required.</mat-error>
              <mat-error *ngIf="
                createLeadForm.get('expectedCloseDate')!.hasError('pastDate')
              "> Date cannot be in the past.</mat-error>
            </span>
          </div>
        </div>
        <div class="form-wrapper">
          <label for="">Notes<span class="red">*</span></label>
          <mat-form-field>
            <textarea matInput placeholder="Enter Notes" formControlName="notes"></textarea>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
              createLeadForm.get('notes')!.invalid &&
              createLeadForm.get('notes')!.touched
            " class="error">Notes is required.</mat-error>
            </span>
          </div>
        </div>
        <div class="form-wrapper">
          <label for="">Probability<span class="red">*</span></label>
          <mat-form-field>
            <input matInput placeholder="Enter Probability" formControlName="probability" />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error *ngIf="
              createLeadForm.get('probability')!.invalid &&
              createLeadForm.get('probability')!.touched
            " class="error">Probability is required.</mat-error>
              <mat-error *ngIf="
              createLeadForm.get('probability')!.hasError('min')
            " class="error">Probability value should be between 0 and 100.</mat-error>
              <mat-error *ngIf="
              createLeadForm.get('probability')!.hasError('max')
            " class="error">Probability value should be between 0 and 100.</mat-error>
              <mat-error *ngIf="
              createLeadForm.get('probability')!.hasError('numbersOnly')
            " class="error">Probability value should a number .</mat-error>
            </span>
          </div>
        </div>
      </div>
      <div class="submit-btn-wrapper">
        <button class="cmn-cancel-btn" (click)="onCancel()" type="button">Cancel</button>
        <button class="cmn-next-btn" (click)="onSave()" type="submit">Save</button>
      </div>
    </form>
  </section>